import tippy from "tippy.js"

export default function init() {
  if (document.querySelector("[data-tippy-content]")) {
    tippy("[data-tippy-content]", { placement: "bottom" })
  }
}
